export const GridData=[
    {
        id:1,
        title:"Curriculum Based on Industry Needs",
        description:"Save time and money! The Belajar curriculum is made to be easier to understand and in line with industry needs.",
    },
    {
        id:2,
        title:"Our Learning Methods",
        description:"The learning process uses the namely online and offline.",
    },
    {
        id:3,
        title:"Certification",
        description:"You will get a certificate that can be used as a certification during job hunting.",
    },
    {
        id:4,
        title:'Rating "Auto-grading"',
        description:"You will immediately get feedback during the learning process without having to wait for an answer or response from the mentor.",
    },
    {
        id:5,
        title:'Ready to Work',
        description:"Connected with over 150+ hiring partners, you will have the opportunity to find a job after graduating from our program.",
    },
]